import { useVehicleAllocationStore } from '@/pages/VehicleAllocationController/store'
import { DndContext, DragEndEvent, DragStartEvent } from '@dnd-kit/core'
import { PropsWithChildren } from 'react'

export const DndContextAllocation = ({ children }: PropsWithChildren) => {
    const { allocationChanges, setAllocationChanges, setActiveId } = useVehicleAllocationStore()
    const handleDragStart = (event: DragStartEvent) => {
        setActiveId(event.active.id)
    }

    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event
        setActiveId(null)

        if (!over) return

        const activeRun = active.id
        const activeBonnet = active.data.current?.bonnet
        const overRun = over.id
        const overBonnet = over.data.current?.bonnet

        if (!activeRun || !overRun) return
        if (activeRun === overRun) return

        // check if allocation was previously changed
        const filteredAllocationChanges = allocationChanges.filter(
            (allocationChange) => allocationChange.run !== activeRun && allocationChange.run !== overRun
        )

        setAllocationChanges([
            ...filteredAllocationChanges,
            {
                run: activeRun.toString(),
                fleetNumber: overBonnet,
            },
            {
                run: overRun.toString(),
                fleetNumber: activeBonnet,
            },
        ])
    }
    return (
        <DndContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
            {children}
        </DndContext>
    )
}
